import { RootState } from "@/app/store";

export const selectLeaveRequests = (state: RootState) => state.users.users;
export const selectLeaveRequestsSearchResults = (state: RootState) =>
  state.users.searchResults;
